import { create } from 'zustand';
import { logger } from '../utils/logger';

/**
 * UI state store for topics
 * This store handles UI-only state that doesn't need to be persisted to the server
 */
interface TopicUIState {
  // Selection state
  activeTopicId: string | null;
  setActiveTopicId: (id: string | null) => void;

  // Creation state
  isCreatingTopic: boolean;
  setIsCreatingTopic: (isCreating: boolean) => void;

  // Loading states (these are separate from data loading in React Query)
  initialLoadComplete: boolean;
  setInitialLoadComplete: (complete: boolean) => void;

  // Reset state
  resetTopicUIState: () => void;
}

export const useTopicUIStore = create<TopicUIState>(set => ({
  // Selection state
  activeTopicId: null,
  setActiveTopicId: id => {
    // Skip if no actual change (to avoid unnecessary renders)
    set(state => {
      if (state.activeTopicId === id) return state;

      logger.store('Setting active topic ID', { id });
      return { activeTopicId: id };
    });
  },

  // Creation state
  isCreatingTopic: false,
  setIsCreatingTopic: isCreating => set({ isCreatingTopic: isCreating }),

  // Loading states
  initialLoadComplete: false,
  setInitialLoadComplete: complete => set({ initialLoadComplete: complete }),

  // Reset state when changing projects
  resetTopicUIState: () => {
    logger.store('Resetting topic UI state');
    set({
      activeTopicId: null,
      isCreatingTopic: false,
      initialLoadComplete: false,
    });
  },
}));
